<template>
  <div class="ph-special-main">
    <div class="surgic-star-detail ssm">


      <!-- ================= 1. Hero ================= -->
      <section class="ssm-hero">
        <div class="ssm-hero-bg">
          <img :src="assets.hero" alt="Surgic Star">
        </div>

        <p class="ssm-hero-sub">3-in-1 Advanced Surgical System</p>
        <!-- 产品名称：使用素材 pic/产品名称.png（设计稿字标为宽字距特殊字形） -->
        <img class="ssm-hero-name" :src="assets.productName" alt="Surgic Star">

        <p class="ssm-hero-line ssm-l1">One System. Multiple Applications</p>
        <p class="ssm-hero-line ssm-l2">Seamless Collaboration</p>
        <p class="ssm-hero-line ssm-l3">Built on Expertise</p>

        <div class="ssm-hero-btn" @click="openVideoModal(videoList[0].previewVideo)">
          <span>Watch Video</span>
          <svg class="ssm-play" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="22.5" fill="none" stroke="#ffffff" stroke-width="3"/>
            <path d="M20 15.4 L33.2 24 L20 32.6 Z" fill="#ffffff"/>
          </svg>
        </div>
      </section>

      <!-- ================= 2. 宣传片视频 ================= -->
      <div class="promotional-cover ssm-video" v-observe-visibility="(isVisible) => handleVisibility(isVisible, 0)">
        <div class="progress">
          <circular-progress :progress="videoList[0].progress" :isPlaying="videoList[0].playing" index="0" @togglePlay="togglePlay"/>
        </div>
        <video class="background-video"
               :ref="videoList[0].ref"
               :src="videoList[0].video"
               :poster="assets.videoCover"
               muted
               playsinline
               loop
        ></video>
      </div>

      <!-- ================= 3. 三种模式 ================= -->
      <section class="ssm-modes">
        <h3 class="ssm-mode-title ssm-mode-t1">Piezo Mode</h3>
        <p class="ssm-mode-sub ssm-mode-s1">Selective Cutting, Enhanced Safety</p>

        <h3 class="ssm-mode-title ssm-mode-t2">Implant Mode</h3>
        <p class="ssm-mode-sub ssm-mode-s2">Precise, Efficient, Stable &amp; Controlled</p>

        <h3 class="ssm-mode-title ssm-mode-t3">Surgical Mode</h3>
        <p class="ssm-mode-sub ssm-mode-s3">Precise Control, Efficient &amp; Safe</p>
      </section>

      <!-- ================= 4. 三模式场景大图 ================= -->
      <section class="ssm-photo">
        <img :src="assets.photo" alt="Implant / Surgical / Piezo">
      </section>

      <!-- ================= 5. 01 PIEZOSURGERY ================= -->
      <section class="ssm-chap">
        <img class="ssm-chap-num" :src="assets.chapNum" alt="01">

        <h3 class="ssm-chap-title">PIEZOSURGERY</h3>
        <span class="ssm-chap-bar"></span>

        <img class="ssm-chap-photo" :src="assets.chapPhoto" alt="Piezosurgery handpiece">

        <div class="ssm-chap-panel">
          <ul class="ssm-tabs">
            <li class="ssm-tab"><span>Bone Cutting</span></li>
            <li class="ssm-tab"><span>Perio</span></li>
            <li class="ssm-tab"><span>Endo</span></li>
            <li class="ssm-tab"><span>Rinsing</span></li>
          </ul>

          <!-- 参数说明（01 PIEZOSURGERY 第一组）-->
          <h4 class="ssm-spec-t ssm-spec-t1">Minimally invasive cutting</h4>
          <p class="ssm-spec-o ssm-spec-o1">Lateral Tip Amplitude: &le;30 &micro;m</p>
          <p class="ssm-spec-d ssm-spec-d1">Reduced surgical trauma, faster recovery</p>

          <!-- 参数说明（第二组）-->
          <h4 class="ssm-spec-t ssm-spec-t2">Preserving Soft Tissues</h4>
          <p class="ssm-spec-o ssm-spec-o2">Operating Frequency: 30 kHz &plusmn; 4.5 kHz</p>
          <p class="ssm-spec-d ssm-spec-d2">Selective cutting for enhanced<br>surgical safety</p>

          <!-- 手柄特写 + 声波弧线 -->
          <img class="ssm-pw-hp" :src="assets.pwHandpiece" alt="Piezosurgery handpiece tip">
          <img class="ssm-pw-wave" :src="assets.pwWave" alt="">

          <!-- 功率档位 -->
          <h3 class="ssm-pw-h1">10 Adjustable Power Levels</h3>
          <h3 class="ssm-pw-h2">Dual Output Modes</h3>

          <p class="ssm-pw-copy ssm-pw-copy1">Enhanced handpiece<br>for improved energy<br>transfer efficiency</p>
          <p class="ssm-pw-copy ssm-pw-copy2">Boosted power output<br>and one-touch handpiece<br>light control</p>

          <!-- 两种输出模式曲线 -->
          <div class="ssm-pw-chart ssm-pw-chart1">
            <img :src="assets.chartHard" alt="">
            <span class="ssm-pw-cap">Hard Mode</span>
          </div>
          <div class="ssm-pw-chart ssm-pw-chart2">
            <img :src="assets.chartSoft" alt="">
            <span class="ssm-pw-cap">Soft Mode</span>
          </div>

          <!-- 切割效率对比 -->
          <h3 class="ssm-eff-h1">34.6% Higher</h3>
          <h3 class="ssm-eff-h2">Cutting Efficiency</h3>

          <p class="ssm-eff-t1">Test condition: bovine cortical bone,</p>
          <p class="ssm-eff-t2">20 mm cutting width &times; 3.3 mm thickness</p>

          <span class="ssm-eff-bar ssm-eff-bar1"></span>
          <p class="ssm-eff-cap ssm-eff-cap1">Surgic Star: 20.41s</p>

          <span class="ssm-eff-bar ssm-eff-bar2"></span>
          <p class="ssm-eff-cap ssm-eff-cap2">3rd-Gen Piezo Bone Surgery Unit: 27.48s</p>

          <!-- Boost 25% + 控制面板大图 -->
          <h3 class="ssm-boost-h">Boost</h3>
          <!-- 25% 与说明放在同一行内排版：说明的起点由 25% 的实际渲染宽度决定，
               避免两者各自硬编码 left、字体度量一变就互相压字 -->
          <div class="ssm-boost-line">
            <p class="ssm-boost-pct">25%</p>
            <p class="ssm-boost-note">instant power increase</p>
          </div>
          <img class="ssm-boost-pad" :src="assets.boostTablet" alt="Surgic Star control panel">
        </div>
      </section>

      <!-- ============ 02 SURGICAL（设计稿 y10384 起） ============ -->
      <section class="ssm-surg">
        <!-- 白色卡片：按钮与后续段落共用同一块白底（设计稿 y11591–17041） -->
        <div class="ssm-surg-card"></div>

        <!-- 蓝色「2 SURGICAL」品牌图形 -->
        <img class="ssm-surg-num" :src="assets.surgNum" alt="02 Surgical">

        <!-- 手柄喷水切割牙体特写 -->
        <img class="ssm-surg-photo" :src="assets.surgPhoto" alt="Piezosurgery handpiece cutting bone">

        <!-- 四项适应症 -->
        <div class="ssm-surg-row ssm-surg-row1">
          <span class="ssm-surg-btn">Bone Removal</span>
          <span class="ssm-surg-btn">Tooth Sectioning</span>
        </div>
        <div class="ssm-surg-row ssm-surg-row2">
          <span class="ssm-surg-btn">Space Creation</span>
          <span class="ssm-surg-btn">Socket Debridement</span>
        </div>

        <!-- 无刷电机：标题 + 副标题 -->
        <h3 class="ssm-motor-h1">High-Performance</h3>
        <h3 class="ssm-motor-h2">Brushless Motor</h3>
        <p class="ssm-motor-s1">Precise speed control, more powerful</p>
        <p class="ssm-motor-s2">More durable, quieter operation</p>

        <!-- 电机整机图 + 左右参数 -->
        <img class="ssm-motor-img" :src="assets.motor" alt="High-performance brushless motor">
        <p class="ssm-motor-torque">80N&middot;cm</p>
        <p class="ssm-motor-note ssm-motor-torque-cap">output torque</p>
        <p class="ssm-motor-speed">126000r/min</p>
        <p class="ssm-motor-note ssm-motor-speed-cap">Max. speed</p>

        <!-- 转速条 Speed 110000 rpm -->
        <span class="ssm-motor-label">Speed</span>
        <span class="ssm-motor-value">110000</span>
        <span class="ssm-motor-unit">r/min</span>
        <span class="ssm-motor-track"><i class="ssm-motor-fill"></i></span>

        <!-- 1:3 增速弯机说明 -->
        <span class="ssm-motor-plus"></span>
        <p class="ssm-motor-gear">With 1:3 speed-increasing contra-angle:</p>
        <span class="ssm-motor-minus"></span>
        <p class="ssm-motor-up">up to <em>126000</em> r/min</p>

        <!-- ---------- Triple Spray 三方喷雾弯机（设计稿 y13668–15855） ---------- -->
        <h3 class="ssm-spray-h ssm-spray-h1">Triple Spray</h3>
        <h3 class="ssm-spray-h ssm-spray-h2">Contra-Angle</h3>
        <h3 class="ssm-spray-h ssm-spray-h3">Handpiece System</h3>

        <p class="ssm-spray-s ssm-spray-s1">Compatible with various bur lengths</p>
        <p class="ssm-spray-s ssm-spray-s2">Optimized cooling for burs</p>
        <p class="ssm-spray-s ssm-spray-s3">Anti-retraction design</p>
        <p class="ssm-spray-s ssm-spray-s4">Enhanced safety and reliability</p>

        <!-- 三方喷雾手柄特写（含雾化与气流箭头，从设计稿裁切 915×1015） -->
        <img class="ssm-spray-img" :src="assets.sprayHandle" alt="Triple spray contra-angle handpiece">

        <!-- 噪音对比柱状图（设计稿裁切 917×485，含标题与图例） -->
        <img class="ssm-noise-img" :src="assets.noiseChart" alt="Noise level comparison">

        <!-- ---------- German Bearings（设计稿 y15994–16909） ---------- -->
        <h3 class="ssm-bear-h">German Bearings</h3>
        <p class="ssm-bear-s ssm-bear-s1">Smoother rotation for more precise cutting</p>
        <p class="ssm-bear-s ssm-bear-s2">Compatible with various contra-angle gear ratios</p>

        <!-- 四个速比 1:1 / 1:3 / 1:4.2 / 1:5：素材 pic/转速比1.png（1360×165）
             设计稿四组间距并不等距（51 / 40 / 39 设计px），素材本身是等距的，
             整张等比缩放会让第 2~4 组最多左移 9px；因此按组开裁切窗口摆放，
             素材统一铺成 353.6×42.9（设计px，= 1360×165 × 0.26），每组只露出自己那一段 -->
        <span class="ssm-bear-ratios">
          <span class="ssm-bear-r ssm-bear-r1"><img :src="assets.ratio1" alt="1:1, 1:3, 1:4.2, 1:5 contra-angle gear ratios"></span>
          <span class="ssm-bear-r ssm-bear-r2"><img :src="assets.ratio1" alt="" aria-hidden="true"></span>
          <span class="ssm-bear-r ssm-bear-r3"><img :src="assets.ratio1" alt="" aria-hidden="true"></span>
          <span class="ssm-bear-r ssm-bear-r4"><img :src="assets.ratio1" alt="" aria-hidden="true"></span>
        </span>

        <!-- 手柄与轴承放大插图（设计稿裁切 880×596） -->
        <img class="ssm-bear-img" :src="assets.gearHandle" alt="Contra-angle handpiece with German bearings">

        <!-- Z IMPLANT 品牌标识（设计稿 x378 y17253，349×492） -->
        <img class="ssm-brand-logo" :src="assets.brandLogo" alt="Z Implant">
      </section>

      <!-- ---------- 5 Preset Implant Programs（设计稿 y17942–19349） ---------- -->
      <section class="ssm-impl">
        <div class="ssm-impl-card"></div>

        <!-- 棕色深色卡：手柄与钻头特写（设计稿 1030×559，顶边圆角） -->
        <img class="ssm-impl-banner" :src="assets.implantBanner" alt="Implant handpiece with drill bit">

        <h3 class="ssm-impl-h">5 Preset Implant Programs</h3>

        <!-- 五个预设程序：上排 3 个，下排 2 个（各 309×181） -->
        <img class="ssm-impl-tile ssm-impl-t1" :src="assets.prog1" alt="Marking">
        <img class="ssm-impl-tile ssm-impl-t2" :src="assets.prog2" alt="Pilot Drilling">
        <img class="ssm-impl-tile ssm-impl-t3" :src="assets.prog3" alt="Template Drilling">
        <img class="ssm-impl-tile ssm-impl-t4" :src="assets.prog4" alt="Implanting">
        <img class="ssm-impl-tile ssm-impl-t5" :src="assets.prog5" alt="Rinsing">

        <span class="ssm-impl-lab ssm-impl-l1">Marking</span>
        <span class="ssm-impl-lab ssm-impl-l2">Pilot Drilling</span>
        <span class="ssm-impl-lab ssm-impl-l3">Template Drilling</span>
        <span class="ssm-impl-lab ssm-impl-l4">Implanting</span>
        <span class="ssm-impl-lab ssm-impl-l5">Rinsing</span>

        <!-- Swiss Brushless Motor 标题（两行，MiSans-Medium 59.5px #000） -->
        <h3 class="ssm-impl-h2">
          <span class="ssm-h2-l ssm-h2-l1">Swiss Brushless Motor</span>
          <span class="ssm-h2-l ssm-h2-l2">Powerful Performance</span>
        </h3>

        <!-- 四行说明（MiSans-Normal 30px #666，行距 46px） -->
        <p class="ssm-impl-desc">
          <span class="ssm-desc-l ssm-desc-l1">Consistent torque maintenance during implant placement</span>
          <span class="ssm-desc-l ssm-desc-l2">Maintains continuous torque output for precise implant placement</span>
          <span class="ssm-desc-l ssm-desc-l3">Real-time speed and torque display with peak torque indication</span>
          <span class="ssm-desc-l ssm-desc-l4">LED motor for enhanced visibility throughout implant surgery</span>
        </p>

        <!-- 无刷电机剖面图（设计稿 x37 y20149，1001×339） -->
        <img class="ssm-impl-motor" :src="assets.motorCross" alt="Swiss brushless motor cross-section">

        <!-- 扭矩读数：Torque 35 N·cm + 渐变进度条 -->
        <span class="ssm-tq-lab">Torque</span>
        <img class="ssm-tq-num" :src="assets.torque35" alt="35">
        <span class="ssm-tq-unit">N&middot;cm</span>
        <div class="ssm-tq-bar"><i class="ssm-tq-fill"></i></div>

        <!-- 减速比说明（max. torque 80 N·cm 为橙色） -->
        <p class="ssm-tq-note">
          <span class="ssm-tq-n ssm-tq-n1">With 20:1 reduction contra-angle</span>
          <span class="ssm-tq-n ssm-tq-n2">max. torque <em>80 N&middot;cm</em></span>
        </p>

        <!-- 植入演示照片：弯机头植入种植体（设计稿 x37 y21128，1031×697） -->
        <img class="ssm-th-photo" :src="assets.torquePhoto" alt="Contra-angle handpiece placing an implant">

        <!-- Torque Holding Function 标题（MiSans-Demibold 57px #000） -->
        <h3 class="ssm-th-h">Torque Holding Function</h3>

        <!-- 六行说明（MiSans-Medium 39px #646464，行距 63.4px） -->
        <p class="ssm-th-desc">
          <span class="ssm-th-d ssm-th-d1">Maintains the required insertion torque</span>
          <span class="ssm-th-d ssm-th-d2">for adequate bone compression</span>
          <span class="ssm-th-d ssm-th-d3">Ensures consistent screw preload,</span>
          <span class="ssm-th-d ssm-th-d4">eliminating the spring fatigue</span>
          <span class="ssm-th-d ssm-th-d5">and calibration drift of</span>
          <span class="ssm-th-d ssm-th-d6">manual torque wrenches</span>
        </p>

        <!-- 两组 F–T 曲线（设计稿 379×198 / 380×196，整块切图） -->
        <img class="ssm-th-graph ssm-th-g1" :src="assets.torqueCurveA" alt="Torque holding curve">
        <img class="ssm-th-graph ssm-th-g2" :src="assets.torqueCurveB" alt="Traditional motor torque curve">

        <!-- 左右对比：啄木鸟电机 vs 传统电机（标题彩底 + 灰色正文） -->
        <p class="ssm-th-col ssm-th-col-l">
          <span class="ssm-th-ch ssm-th-ch1">Woodpecker implant motor:</span>
          <span class="ssm-th-cl ssm-th-cl1">maintains torque at the</span>
          <span class="ssm-th-cl ssm-th-cl2">preset level until the</span>
          <span class="ssm-th-cl ssm-th-cl3">foot pedal is released,</span>
          <span class="ssm-th-cl ssm-th-cl4">for better control of</span>
          <span class="ssm-th-cl ssm-th-cl5">insertion force and</span>
          <span class="ssm-th-cl ssm-th-cl6">improved implant</span>
          <span class="ssm-th-cl ssm-th-cl7">survival rate</span>
        </p>

        <p class="ssm-th-col ssm-th-col-r">
          <span class="ssm-th-ch ssm-th-ch2">Traditional implant motors:</span>
          <span class="ssm-th-cr ssm-th-cr1">stop output immediately</span>
          <span class="ssm-th-cr ssm-th-cr2">upon reaching the preset</span>
          <span class="ssm-th-cr ssm-th-cr3">torque, potentially</span>
          <span class="ssm-th-cr ssm-th-cr4">affecting the</span>
          <span class="ssm-th-cr ssm-th-cr5">intended preload</span>
        </p>

        <!-- ---------- German Bearings / Hygienic Head System ---------- -->
        <!-- 弯机剖面图：整张素材一张到底（12.png 按 0.8618 缩放，墨迹对齐设计稿 x601 y23224），无接缝 -->
        <img class="ssm-gb-img ssm-gb-hand" :src="assets.handpiece" alt="Contra-angle handpiece cross-section">

        <h3 class="ssm-gb-h"><span class="ssm-gb-hl ssm-gb-hl1">German Bearings</span></h3>

        <p class="ssm-gb-sub">
          <span class="ssm-gb-s ssm-gb-s1">Handpiece runout:</span>
          <span class="ssm-gb-s ssm-gb-s2">&lt; 20 &micro;m</span>
        </p>

        <h3 class="ssm-gb-h">
          <span class="ssm-gb-hl ssm-gb-hl2">Hygienic Head</span>
          <span class="ssm-gb-hl ssm-gb-hl3">System</span>
        </h3>

        <p class="ssm-gb-desc">
          <span class="ssm-gb-d ssm-gb-d1">Anti-retraction design</span>
          <span class="ssm-gb-d ssm-gb-d2">Enhanced safety</span>
          <span class="ssm-gb-d ssm-gb-d3">and reliability</span>
          <span class="ssm-gb-d ssm-gb-d4">Compatible with implant</span>
          <span class="ssm-gb-d ssm-gb-d5">contra-angle handpieces</span>
          <span class="ssm-gb-d ssm-gb-d6">of various speed ratios</span>
        </p>

        <!-- 速比 16:1 / 20:1 / 27:1：素材 pic/转速比2.png（1487×212，#FF7033） -->
        <img class="ssm-gb-ratios" :src="assets.ratio2" alt="16:1, 20:1 and 27:1 speed ratios">
      </section>

      <!-- ---------- 7-Inch Color Touchscreen ---------- -->
      <section class="ssm-ts">
        <div class="ssm-ts-card"></div>
        <h3 class="ssm-ts-h"><span class="ssm-ts-o">7-Inch</span> <span class="ssm-ts-b">Color Touchscreen</span></h3>
        <p class="ssm-ts-desc">
          <span class="ssm-ts-d ssm-ts-d1">One-touch mode switching with</span>
          <span class="ssm-ts-d ssm-ts-d2">QR Code recognition for handpieces</span>
          <span class="ssm-ts-d ssm-ts-d3">and contra-angle handpieces.</span>
          <span class="ssm-ts-d ssm-ts-d4">Automatic mode switching</span>
          <span class="ssm-ts-d ssm-ts-d5">with voice guidance</span>
          <span class="ssm-ts-d ssm-ts-d6">Effectively prevents operating errors</span>
        </p>
      </section>

      <section class="ssm-bs">
        <img class="ssm-bs-photo" :src="assets.bsPhoto" alt="Surgical unit with 7-inch color touchscreen in use">
        <h3 class="ssm-bs-h">Bicolor Smart Interface</h3>
        <p class="ssm-bs-sub">
          <span class="ssm-bs-s ssm-bs-s1">Clear and intuitive user interface</span>
          <span class="ssm-bs-s ssm-bs-s2">Easy mode identification</span>
        </p>
        <img class="ssm-bs-panel" :src="assets.bsPanel" alt="Bicolor smart interface screen">
        <p class="ssm-bs-legend">
          <span class="ssm-bs-blue">Blue:</span>
          <span class="ssm-bs-blk">Implant motor+ Surgical motor</span>
        </p>
      </section>

      <!-- ---------- Dual Irrigation Supply System ---------- -->
      <section class="ssm-ds">
        <img class="ssm-ds-panel" :src="assets.dsPanel" alt="Green piezosurgery interface screen">
        <p class="ssm-ds-legend">
          <span class="ssm-ds-green">Green:</span>
          <span class="ssm-ds-blk">Piezosurgery</span>
        </p>
        <h3 class="ssm-ds-h">Dual Irrigation Supply System</h3>
        <p class="ssm-ds-desc">
          <span class="ssm-ds-d ssm-ds-d1">Automatic irrigation line switching based</span>
          <span class="ssm-ds-d ssm-ds-d2">on the selected operating mode.</span>
          <span class="ssm-ds-d ssm-ds-d3">Color-coded tubing matches interface colors</span>
          <span class="ssm-ds-d ssm-ds-d4">to prevent incorrect installation</span>
        </p>
      </section>

      <!-- ---------- Irrigation photo + Wireless Foot Pedal ---------- -->
      <section class="ssm-ir">
        <img class="ssm-ir-photo" :src="assets.irPhoto" alt="Dual irrigation system with color-coded tubing and handpieces">
        <h3 class="ssm-ir-h">Wireless Foot Pedal</h3>
        <p class="ssm-ir-desc">
          <span class="ssm-ir-d ssm-ir-d1">Flexible, hands-free operation</span>
          <span class="ssm-ir-d ssm-ir-d2">No cables in the working area</span>
          <span class="ssm-ir-d ssm-ir-d3">Unrestricted placement in the operatory</span>
          <span class="ssm-ir-d ssm-ir-d4">Greater flexibility and convenience</span>
          <span class="ssm-ir-d ssm-ir-d5">during procedures</span>
        </p>
      </section>

      <!-- ---------- Wireless foot pedal photo + Meets Diverse Clinical Needs scene ---------- -->
      <section class="ssm-sw">
        <img class="ssm-sw-pedal" :src="assets.swPedal" alt="Wireless foot pedal with colour-coded control buttons">
        <img class="ssm-sw-bg" :src="assets.swClinic" alt="Portable dental cart and treatment chair by a lakeside window">
        <h3 class="ssm-sw-h">Meets Diverse Clinical Needs</h3>
        <p class="ssm-sw-desc">
          <span class="ssm-sw-d ssm-sw-d1">One portable system for multiple</span>
          <span class="ssm-sw-d ssm-sw-d2">clinical applications</span>
          <span class="ssm-sw-d ssm-sw-d3">Optional mobile dental cart</span>
        </p>
      </section>

      <video-modal ref="videoModalRef"></video-modal>

    </div>
  </div>
</template>

<script>
import videoModal from '../components/video-modal.vue'
import circularProgress from "../components/progress-circle.vue";
import viewButton from './components/button.vue'

export default {
  components: {
    circularProgress,
    videoModal,
    viewButton
  },
  name: 'surgic-star',
  data() {
    return {
      // 本地素材按项目约定用 require 打包
      assets: {
        hero: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/3996512a55f6ba624b01b06c80c4b3a9.jpg",
        productName: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/b104fa0a9e948c1c02bca64c81c981e1.png",
        videoCover: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/0dbceb78defd2709a3cf62f9788b9024.jpg",
        photo: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/5fdae51cc04ed8d446fe25534729505e.jpg",
        chapNum: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/b8df6cb453a002a8f869396b0670b38e.png",
        chapPhoto: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/24615207e302e8d09c055a2cc9ed5fdf.png",
        pwHandpiece: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/60d948fa431142026651725893f66928.png",
        pwWave: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/6f09d62091551ba9a48bf27ad4744134.png",
        chartHard: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/3b917db0d8e89e74d11fea3928088fa8.png",
        chartSoft: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/cd0faa9b20cf6de1ec85719a7816e7f7.png",
        boostTablet: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/d6bc213c676999111ed4ac444545cd74.png",
        surgNum: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/939b6deb3db6f07cb854a822c827f6fd.png",
        surgPhoto: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/2237db1e27d390012136b3649f97d0a6.png",
        motor: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261025/b85512fefc285eecb430aa4342d363eb.png",
        sprayHandle: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/1ba50be546ef8bb435d9829c10204bf7.png",
        noiseChart: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/c3b9f8b04b5c689febbdd01ef605a81c.png",
        gearRatio: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/487bb75fc19589e505fb042d058f20b3.png",
        ratio1: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/cb8e333f832f63694525b58517866814.png",
        gearHandle: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/6a44e6371cf4207e9dc01e1f18df2d0a.png",
        brandLogo: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/35f8dd7371af0afea5df40a3b043722f.png",
        implantBanner: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/f638aae842236012021b7362223a634f.png",
        prog1: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/cc22edce77bc04bca68636f6bee4c182.png",
        prog2: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/625cbd4f832ad031a3ecb143c8aa2c80.png",
        prog3: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/b90d3402e0efb2e3e17872d9a7fe485b.png",
        prog4: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/641ca51cbb6f634cac53ab0686a9628c.png",
        prog5: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/8bd43ef4018492a6933efbd3ebd7c71e.png",
        motorCross: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/40f8ec76821b39de84039b8e3eb4dc5e.png",
        torque35: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/d6bc614a9772b8c7592e5df6a2d902fb.png",
        torquePhoto: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/6005bb1d14ea7040c79261ea5c0fbdb1.png",
        torqueCurveA: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/299d450c055c7f18f2078fdd26c28310.png",
        torqueCurveB: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/ed6c7b5591454921293590ef7d449344.png",
        handpiece: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/f533d0e7cb2e609fed272633ce2b397f.png",
        ratio2: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/4663a0274ab0dc5e5a0f930b7895b07d.png",
        bsPhoto: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/8859385749b9ca5b17aec34b66522046.png",
        bsPanel: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/98d2154bdf8a09bb61272ee215c7dbc4.png",
        dsPanel: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/ec7436ec740549016af9b2a8a704b2d9.png",
        irPhoto: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/dbc17b0a99b7bc4733c0ed475aa910a0.png",
        swPedal: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/bc2fb0eb6743d09c39655ffe487308e1.png",
        swClinic: "https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20261023/40364e6acfe26b7fd85a846a0eb00341.png"
      },
      videoList: [
        {
          ref: 'promotionalRef',
          video: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/49c889095001834825288099660/JX3BPZC81C8A.mp4',
          progress: 0,
          playing: false,
          previewVideo: 'http://1500005852.vod2.myqcloud.com/6c9a515cvodcq1500005852/c498d8255001834825286963244/5WauehI6TroA.mp4',
          hasEntered: false,
          hasLeft: false
        }
      ]
    }
  },
  mounted() {
    this.setRem()
    window.addEventListener('resize', this.setRem, false)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setRem, false)
    })
  },
  methods: {
    // 移动端 rem 基准：设计稿宽 750，1rem = 100 设计px（与 mobile/endo 一致）
    setRem() {
      const html = document.documentElement
      const designWidth = 750
      html.style.fontSize = html.clientWidth / designWidth * 100 + 'px'
    },
    handleVisibility(isVisible, index) {
      const ref = this.videoList[index].ref
      if (isVisible && !this.videoList[index].hasEntered) {
        this.$refs[ref].play().catch(e => console.log(ref + ' video play failed:', e))
        this.videoList[index].playing = true
        this.videoList[index].hasEntered = true
        this.videoList[index].hasLeft = false
      } else if (!isVisible && !this.videoList[index].hasLeft) {
        this.$refs[ref].pause()
        this.videoList[index].playing = false
        this.videoList[index].hasLeft = true
        this.videoList[index].hasEntered = false
      }
    },
    togglePlay(index) {
      const ref = this.videoList[index].ref
      this.videoList[index].playing = !this.videoList[index].playing
      if (this.videoList[index].playing) {
        this.$refs[ref].play().catch(e => console.log(ref + ' video play failed:', e))
      } else {
        this.$refs[ref].pause()
      }
    },
    openVideoModal(url) {
      this.$refs.videoModalRef.open(url)
    }
  }
}
</script>

<style scoped>
/* 设计稿宽 1105px → rem 换算系数 147.333（1rem = 100 设计px @750 基准）*/
.ssm {
  background: #ffffff;
}

.ssm-hero {
  position: relative;
  width: 100%;
}

.ssm-hero-bg img {
  display: block;
  width: 100%;
}

.ssm-hero-sub,
.ssm-hero-line {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  white-space: nowrap;
  line-height: 1;
  text-align: center;
}
.ph-special-main p {
  font-family: 'MiSans-Medium', sans-serif;
}
/* 3-in-1 Advanced Surgical System — 44.8px */
.ssm-hero-sub {
  top: 1.8461rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.304rem;
  color: #1B1B1B;
}

/* 产品名称（素材 pic/产品名称.png，1448×213）—— 设计稿墨迹 x208 y414，689×102 */
.ssm-hero-name {
  position: absolute;
  left: 50%;
  top: 2.8100rem;
  transform: translateX(-50%);
  width: 4.6732rem;
  height: 0.6923rem;
  display: block;
  /* 素材整体偏亮（#121212），压成纯黑以贴合设计稿 #020202 */
  filter: brightness(0);
}

/* 三行说明 — 44.8px / #4B4B4B */
.ssm-hero-line {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.304rem;
  color: #4B4B4B;
}

.ssm-l1 { top: 11.4169rem; }
.ssm-l2 { top: 12.1561rem; }
.ssm-l3 { top: 12.9060rem; }

/* Watch Video 药丸按钮 */
.ssm-hero-btn {
  position: absolute;
  left: 50%;
  top: 14.33rem;
  transform: translateX(-50%);
  width: 2.457rem;
  height: 0.6787rem;
  border-radius: 0.3394rem;
  background: #B2B2B2;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.ssm-hero-btn span {
  font-family: 'MiSans-Demibold', sans-serif;
  font-weight: 700;
  font-size: 0.2383rem;
  color: #ffffff;
  line-height: 1;
  white-space: nowrap;
}

.ssm-play {
  width: 0.3326rem;
  height: 0.3326rem;
  margin-left: 0.1289rem;
  display: block;
  flex: 0 0 auto;
}

/* ================= 2. 宣传片视频（设计稿 1105×556，2:1 视频 cover 填充） ================= */
.ssm-video {
  position: relative;
  width: 100%;
  margin-top: 0.0068rem;
  height: 3.7737rem;
  overflow: hidden;
  background: #000000;
}

.ssm-video .background-video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 设计稿视频区无播放控件，隐藏进度圈 */
.ssm-video .progress {
  //display: none;
}

/* ================= 3. 三种模式 ================= */
.ssm-modes {
  position: relative;
  width: 100%;
  height: 7.1198rem;
  background: #ffffff;
}

.ssm-mode-title,
.ssm-mode-sub {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  white-space: nowrap;
  line-height: 1;
  text-align: center;
}

/* 标题 MiSans-Demibold 71.5px / #000 */
.ssm-mode-title {
  font-family: 'MiSans-Demibold', sans-serif;
  font-weight: 700;
  font-size: 0.4853rem;
  letter-spacing: -0.0012rem;
  color: #000000;
}

/* 副标 MiSans-Medium 43px / #FF7033 */
.ssm-mode-sub {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.2919rem;
  letter-spacing: -0.0016rem;
  color: #FF7033;
}

.ssm-mode-t1 { top: 0.9034rem; }
.ssm-mode-s1 { top: 1.6894rem; }
.ssm-mode-t2 { top: 3.0143rem; }
.ssm-mode-s2 { top: 3.8546rem; }
.ssm-mode-t3 { top: 5.1521rem; }
.ssm-mode-s3 { top: 5.9928rem; }

/* ================= 4. 三模式场景大图（全幅出血，1105×1005，无圆角） ================= */
.ssm-photo {
  position: relative;
  width: 100%;
  font-size: 0;
  line-height: 0;
}

.ssm-photo img {
  display: block;
  width: 100%;
  /* 设计稿该图占 1105×1006，用 rem 定高保证下边界精确 */
  height: 6.8281rem;
}

/* ================= 5. 01 PIEZOSURGERY（灰底 #F5F5F5，设计稿 1105×1726，y4874–6600） ================= */
.ssm-chap {
  position: relative;
  width: 100%;
  height: 37.4000rem;
  background: #F5F5F5;
}

/* 巨型数字 1（品牌字形，按设计稿切图，底板同为 #F5F5F5 故无缝）*/
.ssm-chap-num {
  position: absolute;
  left: 3.2036rem;
  top: 1.3032rem;
  width: 0.8281rem;
  display: block;
}

/* PIEZOSURGERY — MiSans-Demibold 78px / 字距 -0.5px / #17563B（设计稿 y5309–5372，宽 590）*/
.ssm-chap-title {
  position: absolute;
  left: 0;
  right: 0;
  top: 2.9174rem;
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Demibold', sans-serif;
  font-weight: 700;
  font-size: 0.5294rem;
  letter-spacing: -0.0034rem;
  line-height: 1;
  color: #17563B;
  text-align: center;
}

/* 数字下方竖条 73×131 */
.ssm-chap-bar {
  position: absolute;
  left: 3.5226rem;
  top: 3.6244rem;
  width: 0.4955rem;
  height: 0.8892rem;
  background: linear-gradient(180deg, #1E644C 0%, #21705B 100%);
}

/* 手持设备大图 1030×544（3.png 自带上方圆角）*/
.ssm-chap-photo {
  position: absolute;
  left: 0.2546rem;
  top: 5.6479rem;
  width: 6.9910rem;
  display: block;
}

/* 图片下方白底内容区（1105 设计宽下左右各留 37.5）*/
.ssm-chap-panel {
  position: absolute;
  left: 0.2546rem;
  top: 9.3543rem;
  width: 6.9910rem;
  height: 26.2534rem;
  background: #ffffff;
}

/* 四宫格标签 */
.ssm-tabs {
  display: flex;
  gap: 0.2240rem;
  margin: 0;
  padding: 0.2376rem 0.1968rem 0;
  list-style: none;
}

.ssm-tab {
  flex: 1;
  height: 1.6423rem;
  border-radius: 0.1629rem;
  background: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ssm-tab span {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.3054rem;
  letter-spacing: 0.0024rem;
  line-height: 0.3801rem;
  color: #323232;
  text-align: center;
  white-space: pre-line;
}

/* ---------- 标签下方参数说明（标题 / 橙色参数 / 灰色说明）---------- */
.ssm-spec-t,
.ssm-spec-o,
.ssm-spec-d {
  position: absolute;
  margin: 0;
  padding: 0;
  font-weight: 400;
  white-space: nowrap;
}

/* 小标题 MiSans-Demibold 57px / #000 */
.ssm-spec-t {
  left: 0.5939rem;
  font-family: 'MiSans-Demibold', sans-serif;
  font-weight: 700;
  font-size: 0.3869rem;
  line-height: 1;
  color: #000000;
}

/* 橙色参数 MiSans-Medium 39px / #FF6F32 */
.ssm-spec-o {
  left: 0.6007rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.2647rem;
  letter-spacing: -0.0007rem;
  line-height: 1;
  color: #FF6F32;
}

/* 灰色说明 MiSans-Medium 39.1px / #656565 */
.ssm-spec-d {
  left: 0.6007rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.2654rem;
  line-height: 1;
  color: #656565;
}

.ssm-spec-t1 { top: 2.7595rem; }
.ssm-spec-o1 { top: 3.4404rem; left: 0.6041rem; }
.ssm-spec-d1 { top: 3.9903rem; }

.ssm-spec-t2 { top: 5.3318rem; }
.ssm-spec-o2 {
  top: 5.9652rem;
  left: 0.6109rem;
  letter-spacing: -0.0009rem;
}
/* 两行，行距 63px */
.ssm-spec-d2 {
  top: 6.4066rem;
  left: 0.6177rem;
  line-height: 0.4276rem;
}

/* ---------- 手柄特写 + 声波弧线 ---------- */
/* 4.png 画布 1190×675，缩放 0.866 → 1031px 宽 */
.ssm-pw-hp {
  position: absolute;
  left: -0.0034rem;
  top: 7.2964rem;
  width: 6.9977rem;
  display: block;
}

/* 声波.png 画布 296×409，按 192×264 放置（实测 NCC 0.966） */
.ssm-pw-wave {
  position: absolute;
  left: 4.6256rem;
  top: 7.4186rem;
  width: 1.3032rem;
  height: 1.7919rem;
  display: block;
}

/* 大标题：MiSans-Demibold 56.85px */
.ssm-pw-h1,
.ssm-pw-h2 {
  position: absolute;
  left: 0.6007rem;
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Demibold', sans-serif;
  font-weight: 700;
  font-size: 0.3859rem;
  letter-spacing: -0.0007rem;
  line-height: 1;
  white-space: nowrap;
}

/* 10 Adjustable Power Levels — #FF6F32 */
.ssm-pw-h1 {
  left: 0.6075rem;
  top: 10.9376rem;
  color: #FF6F32;
}

/* Dual Output Modes — #323232 */
.ssm-pw-h2 {
  left: 0.6007rem;
  top: 11.5683rem;
  color: #323232;
}

/* 说明文字 MiSans-Medium 39.4px / 行距 63.2px / #656565 */
.ssm-pw-copy {
  position: absolute;
  left: 0.6143rem;
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.2674rem;
  letter-spacing: -0.0004rem;
  line-height: 0.4290rem;
  color: #656565;
  white-space: nowrap;
}

.ssm-pw-copy1 { top: 12.4534rem; }

.ssm-pw-copy2 { top: 13.7410rem; }

/* ---------- 两种输出模式曲线 ---------- */
.ssm-pw-chart {
  position: absolute;
  left: 4.5509rem;
}

.ssm-pw-chart img {
  display: block;
}

.ssm-pw-chart1 {
  top: 12.6176rem;
  width: 1.0928rem;
}

.ssm-pw-chart1 img {
  width: 1.0928rem;
}

.ssm-pw-chart2 {
  top: 13.9959rem;
  width: 1.0182rem;
}

.ssm-pw-chart2 img {
  width: 1.0182rem;
}

/* 曲线下方标注 MinSans-Medium 37.4px / #656565 */
.ssm-pw-cap {
  position: absolute;
  left: 0;
  margin: 0;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.2413rem;
  line-height: 1;
  color: #656565;
  white-space: nowrap;
}

.ssm-pw-chart1 .ssm-pw-cap {
  top: 0.7561rem;
  left: -0.0068rem;
}

.ssm-pw-chart2 .ssm-pw-cap {
  top: 0.7765rem;
  left: -0.0136rem;
}

/* ---------- 切割效率对比（设计稿 y8613–9220） ---------- */
/* 两行大标题 MiSans-Demibold 56.85px */
.ssm-eff-h1,
.ssm-eff-h2 {
  position: absolute;
  left: 0.5921rem;
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Demibold', sans-serif;
  font-weight: 700;
  font-size: 0.3859rem;
  letter-spacing: 0;
  line-height: 1;
  white-space: nowrap;
}

/* 34.6% Higher — #FF7033 */
.ssm-eff-h1 {
  top: 16.0073rem;
  color: #FF7033;
}

/* Cutting Efficiency — #000 */
.ssm-eff-h2 {
  top: 16.6317rem;
  color: #000000;
}

/* 试验条件 MiSans-Medium 39px / 行距 63px / #666666 */
.ssm-eff-t1,
.ssm-eff-t2 {
  position: absolute;
  left: 0.5960rem;
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.2647rem;
  letter-spacing: -0.0004rem;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
}

.ssm-eff-t1 { top: 17.4042rem; }

.ssm-eff-t2 { top: 17.8308rem; }

/* 橙色对比条 #FF7033，直角无圆角 */
.ssm-eff-bar {
  position: absolute;
  left: 0.6075rem;
  display: block;
  background: #FF7033;
}

/* 20.41s — 365×28 */
.ssm-eff-bar1 {
  top: 18.5283rem;
  width: 2.4774rem;
  height: 0.1901rem;
}

/* 27.48s — 603×27 */
.ssm-eff-bar2 {
  top: 19.4379rem;
  width: 4.0927rem;
  height: 0.1901rem;
}

/* 条下方标注 MiSans-Medium 35.5px / #666666 */
.ssm-eff-cap {
  position: absolute;
  left: 0.6007rem;
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.2413rem;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
}

.ssm-eff-cap1 { top: 18.9041rem; }

.ssm-eff-cap2 { top: 19.8801rem; }

/* ---------- Boost 25%（设计稿 y9387–9605） ---------- */
/* Boost MiSans-Demibold 58px / #000；25% MiSans-Demibold 170.9px / #FF7033；
   instant power increase MiSans-Normal 41.24px / #4D4D4D（与 25% 同基线）
   —— 25% 与说明同处 .ssm-boost-line（flex + baseline），说明的起点是「25% 的实际宽度 + 间隙」，
      不再各自写死 left：浏览器更换字体度量（字体未加载 / 系统字号放大 / 合成加粗）时只会整体右移，不会压字 */
.ssm-boost-h,
.ssm-boost-pct,
.ssm-boost-note {
  margin: 0;
  padding: 0;
  letter-spacing: 0;
  line-height: 1;
  white-space: nowrap;
  /* 安卓 Chrome / 微信 X5 的 Text Autosizing 会按文本块独立放大字号：
     短文本块（25%）乘子更大 → 只放大 25%，把说明挤掉。此处禁用自动字号缩放 */
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

.ssm-boost-h {
  position: absolute;
  left: 0.5752rem;
  top: 21.2459rem;
  font-family: 'MiSans-Demibold', sans-serif;
  font-weight: 400;
  font-size: 0.3937rem;
  color: #000000;
}

/* 行容器：左缘与 25% 原 left 一致，顶边与 25% 原 top 一致（容器高由 25% 行盒决定，故 25% 位置不变）*/
.ssm-boost-line {
  position: absolute;
  left: 0.5396rem;
  top: 21.7169rem;
  display: flex;
  align-items: baseline;
  margin: 0;
  padding: 0;
  white-space: nowrap;
}

.ssm-boost-pct {
  font-family: 'MiSans-Demibold', sans-serif;
  font-weight: 400;
  font-size: 1.1602rem;
  color: #FF7033;
}

/* 说明：与 25% 同基线；间隙用 rem（等比），字体变宽时自动右移 */
.ssm-boost-note {
  position: relative;
  flex: none;
  top: -0.0475rem;          /* baseline 对齐后比设计低 7 设计px，用 relative 微调（不参与布局）*/
  margin-left: 0.2593rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.2799rem;
  color: #4D4D4D;
}

/* 控制面板大图 5.png（792×543 → 1031.2×707.0，设计稿 x36.6 y9477.4）*/
.ssm-boost-pad {
  position: absolute;
  left: 0.0000rem;
  top: 21.8925rem;
  width: 6.9882rem;
  display: block;
}

/* ================= 6. 02 SURGICAL（灰底 #F5F5F5，设计稿 y10384 起） ================= */
.ssm-surg {
  position: relative;
  width: 100%;
  height: 51.2987rem;
  background: #F5F5F5;
}

/* 白色卡片：设计稿 x38–1066 / y11591–17041（按钮与后续段落共用）*/
.ssm-surg-card {
  position: absolute;
  left: 0.2546rem;
  top: 8.1923rem;
  width: 6.9910rem;
  height: 37.2967rem;
  background: #ffffff;
  border-radius: 0 0 0.5362rem 0.5362rem;
}

/* 蓝色「2 SURGICAL」图形：微动力.png（304×381 → 395×495，设计稿 x355 y10385）*/
.ssm-surg-num {
  position: absolute;
  left: 2.4095rem;
  top: 0.0068rem;
  width: 2.6811rem;
  display: block;
}

/* 手柄喷水特写：6.png（1190×617 → 1031×534.4，设计稿 x37 y11057，图自带上方圆角）*/
.ssm-surg-photo {
  position: absolute;
  left: 0.2511rem;
  top: 4.5679rem;
  width: 6.9978rem;
  display: block;
}

/* 四个适应症按钮：两行两列，列间距 30，按钮 472×95 / 圆角 10 / 底色 #F5F5F5 */
.ssm-surg-row {
  position: absolute;
  left: 0.4480rem;
  width: 6.6041rem;
  display: flex;
  align-items: stretch;
}

.ssm-surg-row1 { top: 8.4095rem; }
.ssm-surg-row2 { top: 9.2375rem; }

.ssm-surg-btn {
  flex: 1 1 0;
  height: 0.6448rem;
  margin-right: 0.2036rem;
  border-radius: 0.0679rem;
  background: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.2655rem;
  line-height: 1;
  letter-spacing: 0;
  color: #000000;
  white-space: nowrap;
}

.ssm-surg-btn:last-child {
  margin-right: 0;
}

/* ---------- 无刷电机区块（设计稿 y11991–13478） ---------- */
.ssm-motor-h1,
.ssm-motor-h2,
.ssm-motor-s1,
.ssm-motor-s2,
.ssm-motor-torque,
.ssm-motor-note,
.ssm-motor-speed,
.ssm-motor-label,
.ssm-motor-value,
.ssm-motor-unit,
.ssm-motor-gear,
.ssm-motor-up {
  position: absolute;
  margin: 0;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
  letter-spacing: 0;
}

.ssm-motor-h1 {
  left: 1.9748rem;
  top: 10.8835rem;
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 0.3923rem;
  color: #000000;
}

.ssm-motor-h2 {
  left: 2.1719rem;
  top: 11.5134rem;
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 0.3886rem;
  color: #000000;
}

.ssm-motor-s1 {
  left: 1.3254rem;
  top: 12.1147rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.2650rem;
  color: #666666;
}

.ssm-motor-s2 {
  left: 1.6850rem;
  top: 12.5423rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.2653rem;
  color: #666666;
}

/* 电机整机图：素材 904×1037 等比 0.866 铺满，落位 x161 y12319（783×898） */
.ssm-motor-img {
  position: absolute;
  left: 1.0928rem;
  top: 13.1335rem;
  width: 5.3145rem;
  height: 6.0950rem;
  display: block;
}

/* 左右两个参数：橙色数值 Demibold + 灰色说明 Medium */
.ssm-motor-torque {
  left: 1.2249rem;
  top: 15.5600rem;
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 0.3428rem;
  color: #FF7033;
}

.ssm-motor-speed {
  left: 4.7747rem;
  top: 15.5192rem;
  font-family: 'MiSans-Demibold', sans-serif;
  font-size: 0.3430rem;
  color: #FF7033;
}

.ssm-motor-note {
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.2426rem;
  color: #666666;
}

.ssm-motor-torque-cap { left: 1.0351rem; top: 16.0202rem; }
.ssm-motor-speed-cap { left: 4.7681rem; top: 16.0256rem; }

/* 转速条：Speed 110000 rpm */
.ssm-motor-label {
  left: 0.8105rem;
  top: 19.3622rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.2516rem;
  color: #1D1D1B;
}

.ssm-motor-value {
  left: 2.8251rem;
  top: 19.1647rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.5603rem;
  letter-spacing: 0.0244rem;
  color: #FF7033;
}

.ssm-motor-unit {
  letter-spacing: 0.0048rem;
  left: 6.2208rem;
  top: 19.3690rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.2390rem;
  color: #1D1D1B;
}

/* 轨道 #CCCCCC + 渐变进度段（#67D2E2 → #2194FF，占 464/858） */
.ssm-motor-track {
  position: absolute;
  left: 0.8213rem;
  top: 19.8801rem;
  width: 5.8235rem;
  height: 0.1697rem;
  border-radius: 0.0849rem;
  background: #CCCCCC;
  overflow: hidden;
}

.ssm-motor-fill {
  display: block;
  width: 3.1493rem;
  height: 100%;
  background: linear-gradient(90deg, #67D2E2 0%, #2194FF 100%);
}

/* 加号 / 减号：按实测 37×37（线宽 6）与 29×6 用纯色块拼 */
.ssm-motor-plus {
  position: absolute;
  left: 0.8213rem;
  top: 20.2873rem;
  width: 0.2511rem;
  height: 0.2511rem;
}

.ssm-motor-plus::before,
.ssm-motor-plus::after {
  content: '';
  position: absolute;
  background: #1D1D1B;
}

.ssm-motor-plus::before {
  left: 0;
  top: 0.1018rem;
  width: 0.2511rem;
  height: 0.0407rem;
}

.ssm-motor-plus::after {
  left: 0.1018rem;
  top: 0;
  width: 0.0407rem;
  height: 0.2511rem;
}

.ssm-motor-minus {
  position: absolute;
  left: 6.4615rem;
  top: 20.3891rem;
  width: 0.1968rem;
  height: 0.0407rem;
  background: #1D1D1B;
}

.ssm-motor-gear {
  left: 1.4763rem;
  top: 20.3084rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.2423rem;
  color: #1D1D1B;
}

.ssm-motor-up {
  left: 2.7661rem;
  top: 20.7204rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-size: 0.2393rem;
  color: #1D1D1B;
}

.ssm-motor-up em {
  font-style: normal;
  color: #FF7033;
}

/* ---------- Triple Spray 三方喷雾弯机（设计稿 y13668–15855） ---------- */
/* 三行大标题：MiSans-Demibold 58px / #000，整体居中（中心 x552） */
.ssm-spray-h {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Demibold', sans-serif;
  font-weight: 700;
  font-size: 0.3937rem;
  letter-spacing: -0.0030rem;
  line-height: 1;
  color: #000000;
  white-space: nowrap;
}

.ssm-spray-h1 { top: 22.2692rem; }
.ssm-spray-h2 { top: 22.7783rem; }
.ssm-spray-h3 { top: 23.3077rem; }

/* 四行说明：MiSans-Medium 39px / #666，居中 */
.ssm-spray-s {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.2647rem;
  letter-spacing: 0;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
}

.ssm-spray-s1 { top: 24.1493rem; }
.ssm-spray-s2 { top: 24.5769rem; }
.ssm-spray-s3 { top: 25.0045rem; }
.ssm-spray-s4 { top: 25.4321rem; }

/* 手柄特写：设计稿 x150 y14230，915×1015（含雾化与橙色气流箭头） */
.ssm-spray-img {
  position: absolute;
  left: 1.0181rem;
  top: 26.1041rem;
  width: 6.2104rem;
  display: block;
}

/* 噪音柱状图：设计稿 x88 y15370，917×485（含 Noise Level 标题与图例） */
.ssm-noise-img {
  position: absolute;
  left: 0.5973rem;
  top: 33.8416rem;
  width: 6.2240rem;
  display: block;
}

/* German Bearings 标题：MiSans-Demibold 56.9px / #000，居中 */
.ssm-bear-h {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Demibold', sans-serif;
  font-weight: 700;
  font-size: 0.3861rem;
  letter-spacing: 0.0018rem;
  line-height: 1;
  color: #000000;
  white-space: nowrap;
  top: 38.0634rem;
}

/* 两行说明：MiSans-Medium 38.7px / #666，居中 */
.ssm-bear-s {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.2625rem;
  letter-spacing: 0.0015rem;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
}

.ssm-bear-s1 { top: 38.6905rem; letter-spacing: 0.0010rem; }
.ssm-bear-s2 { top: 39.1181rem; }

/* 速比行：素材 pic/转速比1.png，按设计稿四组位置分别裁切摆放
   设计稿墨迹 x370–734 / y16221–16263（365×43）；素材 1360×165 铺成 353.6×42.9（×0.26） */
.ssm-bear-ratios {
  position: absolute;
  left: 2.5113rem;
  top: 39.6177rem;
  width: 2.4000rem;
  height: 0.2912rem;
}

.ssm-bear-r {
  position: absolute;
  top: 0;
  height: 0.2912rem;
  overflow: hidden;
}

.ssm-bear-r img {
  position: absolute;
  top: 0;
  width: 2.4000rem;
  height: 0.2912rem;
  display: block;
}

/* 窗口宽度 = 该组宽度 + 4 设计px（素材组间透明，多出的部分不可见，避免取整裁掉笔画） */
.ssm-bear-r1 { left: 0;        width: 0.3166rem; }
.ssm-bear-r1 img { left: 0; }
.ssm-bear-r2 { left: 0.6380rem; width: 0.3713rem; }
.ssm-bear-r2 img { left: -0.5576rem; }
.ssm-bear-r3 { left: 1.2489rem; width: 0.6483rem; }
.ssm-bear-r3 img { left: -1.1682rem; }
.ssm-bear-r4 { left: 2.1312rem; width: 0.3730rem; }
.ssm-bear-r4 img { left: -2.0541rem; }

/* 手柄 + 轴承放大插图：设计稿 x100 y16324，880×596 */
.ssm-bear-img {
  position: absolute;
  left: 0.6787rem;
  top: 40.3168rem;
  width: 5.9729rem;
  display: block;
}

/* Z IMPLANT 品牌标识：设计稿 x378 y17253，349×492 */
.ssm-brand-logo {
  position: absolute;
  left: 2.5656rem;
  top: 46.6222rem;
  width: 2.3688rem;
  display: block;
}

/* ---------- 5 Preset Implant Programs + Swiss Brushless Motor ---------- */
/* 段高 = 白卡高度：设计 y17942–21384（白卡底边），3442px / 147.333 = 23.3619rem */
.ssm-impl {
  position: relative;
  width: 100%;
  height: 44.3756rem;
  background: #F5F5F5;
  overflow: hidden;
}

/* 白色卡片：设计稿 x38 y17942，宽 1030，圆角 79px，底边 y24483 */
.ssm-impl-card {
  position: absolute;
  left: 0.2546rem;
  top: 0;
  width: 6.9910rem;
  height: 44.3756rem;
  background: #ffffff;
  border-radius: 0.5362rem;
}

/* 棕色深色卡（手柄 + 钻头特写）：设计稿 1030×559，顶边由自带圆角 */
.ssm-impl-banner {
  position: absolute;
  left: 0.2546rem;
  top: 0;
  width: 6.9910rem;
  display: block;
}

/* 标题：MiSans-Demibold 56.7px #000，居中 */
.ssm-impl-h {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.4050rem;
  letter-spacing: 0;
  word-spacing: -0.0360rem;
  line-height: 1;
  color: #000000;
  white-space: nowrap;
  top: 5.0260rem;
}

/* 五个程序示意图：各 309×181 */
.ssm-impl-tile {
  position: absolute;
  width: 2.0973rem;
  display: block;
}

.ssm-impl-t1 { left: 0.4412rem; top: 6.0068rem; }
.ssm-impl-t2 { left: 2.7014rem; top: 6.0068rem; }
.ssm-impl-t3 { left: 4.9615rem; top: 6.0068rem; }
.ssm-impl-t4 { left: 1.5747rem; top: 7.9209rem; width: 2.0905rem; }
.ssm-impl-t5 { left: 3.8348rem; top: 7.9209rem; width: 2.0905rem; }

/* 程序名：MiSans-Medium 35.7px #1D1D1B，居中对齐于各自示意图 */
.ssm-impl-lab {
  position: absolute;
  width: 2.0973rem;
  text-align: center;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.2423rem;
  letter-spacing: 0;
  line-height: 1;
  color: #1D1D1B;
  white-space: nowrap;
}

.ssm-impl-l1 { left: 0.4412rem; top: 7.3847rem; }
.ssm-impl-l2 { left: 2.7014rem; top: 7.3847rem; }
.ssm-impl-l3 { left: 4.9615rem; top: 7.3847rem; }
.ssm-impl-l4 { left: 1.5747rem; top: 9.2851rem; }
.ssm-impl-l5 { left: 3.8348rem; top: 9.2851rem; }

/* ---------- Swiss Brushless Motor / Powerful Performance ---------- */
/* MiSans-Medium 59.5px #000，两行：墨迹顶 y19589 / y19666 */
.ssm-impl-h2 {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  margin: 0;
  padding: 0;
}

.ssm-h2-l {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.4038rem;
  letter-spacing: 0;
  word-spacing: -0.0271rem;
  line-height: 1;
  color: #000000;
  white-space: nowrap;
}

.ssm-h2-l1 { top: 11.1517rem; }
.ssm-h2-l2 { top: 11.6743rem; }

/* ---------- 四行说明 ---------- */
/* MiSans-Medium 29.3px #666666，行距 46px，墨迹顶 y19804 / 19850 / 19896 / 19942 */
.ssm-impl-desc {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  margin: 0;
  padding: 0;
}

.ssm-desc-l {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.1989rem;
  letter-spacing: 0;
  word-spacing: -0.0339rem;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
  transform: translateX(0.0034rem);
}

.ssm-desc-l1 { top: 12.6247rem; }
.ssm-desc-l2 { top: 12.9369rem; }
.ssm-desc-l3 { top: 13.2491rem; }
.ssm-desc-l4 { top: 13.5613rem; }

/* 无刷电机剖面图：设计稿 x37 y20149，1001×339 */
.ssm-impl-motor {
  position: absolute;
  left: 0.2511rem;
  top: 14.9796rem;
  width: 6.7941rem;
  display: block;
}

/* ---------- 扭矩读数 ---------- */
/* Torque：MiSans-Medium 43.6px #666666，墨迹左 x178 顶 y20848 */
.ssm-tq-lab {
  position: absolute;
  left: 1.2014rem;
  top: 19.6968rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.2959rem;
  letter-spacing: 0.0041rem;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
}

/* 数值 35：设计稿为加宽数字，整块裁切 102×68（x493 y20821） */
.ssm-tq-num {
  position: absolute;
  left: 3.3462rem;
  top: 19.5366rem;
  width: 0.6923rem;
  display: block;
}

/* N·cm：MiSans-Medium 44.5px #666666，墨迹左 x799 顶 y20853 */
.ssm-tq-unit {
  position: absolute;
  left: 5.4026rem;
  top: 19.7375rem;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.3021rem;
  letter-spacing: 0;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
}

/* 进度条：设计稿 x178 y20920，741×22，圆角 11 */
.ssm-tq-bar {
  position: absolute;
  left: 1.2014rem;
  top: 20.2092rem;
  width: 5.0297rem;
  height: 0.1493rem;
  border-radius: 0.0747rem;
  background: #494B57;
  overflow: hidden;
}

/* 渐变填充段：x178–578（400px），#69D4E0 → #2393FF */
.ssm-tq-fill {
  display: block;
  width: 2.7149rem;
  height: 100%;
  border-radius: 0.0747rem;
  background: linear-gradient(90deg, #69D4E0 0%, #2393FF 100%);
}

/* ---------- 减速比说明 ---------- */
/* 两行整体居中于设计 x514（比卡片中心左移 38.5px → padding-right 77px） */
.ssm-tq-note {
  position: absolute;
  left: 0;
  top: 0;
  width: 7.5rem;
  margin: 0;
  padding: 0 0.5227rem 0 0;
  box-sizing: border-box;
}

.ssm-tq-n {
  position: absolute;
  left: 0;
  width: 7.5rem;
  box-sizing: border-box;
  padding-right: 0.5023rem;
  text-align: center;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.2675rem;
  letter-spacing: 0;
  word-spacing: -0.0115rem;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
}

.ssm-tq-n1 { top: 20.6658rem; }
.ssm-tq-n2 { top: 21.0322rem; }

/* 橙色高亮：80 N·cm */
.ssm-tq-n2 em {
  font-style: normal;
  color: #FF7034;
}

/* ---------- 植入演示照片（设计稿 x37 y21128，1031×697） ---------- */
.ssm-th-photo {
  position: absolute;
  left: 0.2511rem;
  top: 21.6244rem;
  width: 6.9977rem;
  display: block;
}

/* ---------- Torque Holding Function 标题 ---------- */
/* MiSans-Demibold 57px #000，ink x163 y22008 */
.ssm-th-h {
  position: absolute;
  left: 1.1037rem;
  top: 27.5760rem;
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Demibold', sans-serif;
  font-weight: 400;
  font-size: 0.3869rem;
  letter-spacing: 0;
  word-spacing: 0;
  line-height: 1;
  color: #000000;
  white-space: nowrap;
}

/* ---------- 六行说明（MiSans-Medium 39px #646464） ---------- */
.ssm-th-desc {
  position: absolute;
  left: 1.1042rem;
  top: 0;
  margin: 0;
  padding: 0;
}

.ssm-th-d {
  position: absolute;
  left: 0;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.2647rem;
  letter-spacing: 0;
  word-spacing: 0;
  line-height: 1;
  color: #646464;
  white-space: nowrap;
}

.ssm-th-d1 { top: 28.3258rem; }
.ssm-th-d2 { top: 28.7534rem; }
.ssm-th-d3 { top: 29.1810rem; }
.ssm-th-d4 { top: 29.6154rem; }
.ssm-th-d5 { top: 30.0431rem; }
.ssm-th-d6 { top: 30.4707rem; }

/* ---------- F–T 曲线切图 ---------- */
.ssm-th-graph {
  position: absolute;
  display: block;
}

.ssm-th-g1 { left: 0.9570rem; top: 31.1462rem; width: 2.5724rem; }
.ssm-th-g2 { left: 4.1810rem; top: 31.2276rem; width: 2.5792rem; }

/* ---------- 左右对比列（MiSans-Normal 30px） ---------- */
.ssm-th-col {
  position: absolute;
  top: 0;
  margin: 0;
  padding: 0;
}

.ssm-th-col-l { left: 1.1077rem; }
/*.ssm-th-col-r { left: 4.2774rem; }*/
.ssm-th-col-r { left: 4.2774rem; }

.ssm-th-ch,
.ssm-th-cl,
.ssm-th-cr {
  position: absolute;
  left: 0;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.195rem;
  letter-spacing: 0;
  /*word-spacing: -0.0068rem;*/
  line-height: 1;
  white-space: nowrap;
}

/* 两个对比标题：啄木鸟红 #E85454 / 传统电机绿 #008432 */
.ssm-th-ch1 { top: 33.1357rem; color: #E85454; }
.ssm-th-ch2 { top: 33.1493rem; color: #008432; }

.ssm-th-cl,
.ssm-th-cr { color: #646464; }

.ssm-th-cl1 { top: 33.4009rem; }
.ssm-th-cl2 { top: 33.6586rem; }
.ssm-th-cl3 { top: 33.9166rem; }
.ssm-th-cl4 { top: 34.1746rem; }
.ssm-th-cl5 { top: 34.4393rem; }
.ssm-th-cl6 { top: 34.6973rem; }
.ssm-th-cl7 { top: 34.9552rem; }

.ssm-th-cr1 { top: 33.4412rem; }
.ssm-th-cr2 { top: 33.7262rem; }
.ssm-th-cr3 { top: 34.0113rem; }
.ssm-th-cr4 { top: 34.3032rem; }
.ssm-th-cr5 { top: 34.5883rem; }

/* ========== German Bearings / Hygienic Head System ========== */

/* 弯机剖面图：整张 12.png（1118×1988，等比缩放到墨迹高 1085px）
   缩放比 0.8618 → 图片 963×1713；墨迹左上落在设计稿 x601 y23224 */
.ssm-gb-img {
  position: absolute;
  display: block;
  z-index: 1;
}

.ssm-gb-hand { left: 2.5487rem; top: 33.7245rem; width: 6.5755rem; }

/* 三个标题行：MiSans-Demibold 57.5px #000 */
.ssm-gb-h {
  position: absolute;
  left: 0;
  top: 0;
  margin: 0;
  padding: 0;
}

.ssm-gb-hl {
  position: absolute;
  left: 0;
  font-family: 'MiSans-Demibold', sans-serif;
  font-weight: 400;
  font-size: 0.3869rem;
  letter-spacing: 0;
  word-spacing: 0;
  line-height: 1;
  color: #000000;
  white-space: nowrap;
}

.ssm-gb-hl1 { left: 1.1267rem; top: 36.4615rem; }
.ssm-gb-hl2 { left: 1.0588rem; top: 38.2941rem; letter-spacing: 0.0007rem; }
.ssm-gb-hl3 { left: 1.0588rem; top: 38.9185rem; letter-spacing: 0.0041rem; }

/* Handpiece runout: < 20 μm */
.ssm-gb-sub {
  position: absolute;
  left: 0;
  top: 0;
  margin: 0;
  padding: 0;
}

.ssm-gb-s {
  position: absolute;
  left: 0;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  letter-spacing: 0;
  word-spacing: 0;
  line-height: 1;
  white-space: nowrap;
  color: #646464;
}

.ssm-gb-s1 { left: 1.1267rem; top: 37.0452rem; letter-spacing: 0.0013rem; font-size: 0.2647rem; }
.ssm-gb-s2 { left: 1.1267rem; top: 37.4796rem; letter-spacing: 0.0005rem; font-size: 0.2579rem; color: #FF7034; }

/* 六行说明：MiSans-Medium 39px #646464 */
.ssm-gb-desc {
  position: absolute;
  left: 0;
  top: 0;
  margin: 0;
  padding: 0;
}

.ssm-gb-d {
  position: absolute;
  left: 0;
  font-family: 'MiSans-Medium', sans-serif;
  font-weight: 400;
  font-size: 0.2647rem;
  letter-spacing: 0;
  word-spacing: 0;
  line-height: 1;
  color: #646464;
  white-space: nowrap;
}

.ssm-gb-d1 { left: 1.0995rem; top: 39.5701rem; letter-spacing: 0.0013rem; }
.ssm-gb-d2 { left: 1.0927rem; top: 39.9977rem; letter-spacing: 0.0010rem; }
.ssm-gb-d3 { left: 1.0995rem; top: 40.4253rem; letter-spacing: 0.0010rem; }
.ssm-gb-d4 { left: 1.0859rem; top: 41.3484rem; letter-spacing: 0.0007rem; }
.ssm-gb-d5 { left: 1.0860rem; top: 41.7081rem; letter-spacing: 0.0016rem; }
.ssm-gb-d6 { left: 1.0860rem; top: 42.0611rem; letter-spacing: -0.0003rem; }

/* 减速比 16:1 20:1 27:1：素材 pic/转速比2.png（1487×212，墨迹铺满画布，#FF7033）
   设计稿墨迹 x161–546 / y24226–24280（386×55）—— 素材 0.2596 等比缩放即 386×55，
   三组间距与设计一致（素材组起点 0/544/1120 → 0/141.2/290.8，设计 0/141/291） */
.ssm-gb-ratios {
  position: absolute;
  left: 1.0928rem;
  top: 42.6498rem;
  width: 2.6200rem;
  height: 0.3733rem;
  display: block;
}

/* ---------- 7-Inch Color Touchscreen ---------- */
/* 段顶 = y24480（承接 seg16 白卡底边）；段高 837px = 5.6812rem；卡顶 y24547、卡底 y25317 */
.ssm-ts {
  position: relative;
  width: 100%;
  height: 5.6812rem;
  /* 页面底色自 y24480 起由 #F5F5F5 向 #FFF 线性过渡（实测 24700=246 / 25000=248 / 25300=251） */
  background: linear-gradient(180deg, #F5F5F5 0%, #FBFBFB 100%);
}
/* 白卡：设计 x38 y24547，宽 1030，高 770（底 y25317），圆角 79px */
.ssm-ts-card {
  position: absolute;
  left: 0.2546rem;
  top: 0.4547rem;
  width: 6.9910rem;
  height: 5.2263rem;
  background: #ffffff;
  border-radius: 0.5362rem;
}
/* 标题「7-Inch Color Touchscreen」：57px Demibold，水平居中，ink 顶 y24688 */
.ssm-ts-h {
  position: absolute;
  left: 50%;
  top: 1.3846rem;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Demibold';
  font-size: 0.3869rem;
  letter-spacing: 0;
  word-spacing: -0.00815rem;
  line-height: 1;
  white-space: nowrap;
}
.ssm-ts-o { color: #FF7034; }
.ssm-ts-b { color: #000000; }
/* 六行说明：42.7px Medium #666666，居中，行距 69px */
.ssm-ts-desc { margin: 0; padding: 0; }
.ssm-ts-d {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-family: 'MiSans-Medium';
  font-size: 0.2898rem;
  letter-spacing: 0;
  word-spacing: 0;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
}
.ssm-ts-d1 { top: 2.2601rem; }
.ssm-ts-d2 { top: 2.7285rem; }
.ssm-ts-d3 { top: 3.1969rem; }
.ssm-ts-d4 { top: 3.6652rem; }
.ssm-ts-d5 { top: 4.1335rem; }
.ssm-ts-d6 { top: 4.6020rem; }

/* ---------- Bicolor Smart Interface ---------- */
/* 段顶 = y25317（承接 7-Inch 卡底边 y25317），全宽底；段高 1729px = 11.7353rem（至 y27046） */
.ssm-bs {
  position: relative;
  width: 100%;
  height: 11.7353rem;
  /* 延续自 y24480 的底色渐变：y25317=#FBFBFB → y25900 起纯白 */
  background: linear-gradient(180deg, #FBFBFB 0%, #FFFFFF 33.72%, #FFFFFF 100%);
}
/* 设备照片：设计 x37 y25316，宽 1031、高 616，仅底部圆角 73px（顶边与上一卡底边齐平） */
.ssm-bs-photo {
  position: absolute;
  left: 0.2511rem;
  top: -0.0068rem;
  width: 6.9977rem;
  display: block;
  border-radius: 0 0 0.4955rem 0.4955rem;
}
/* 标题「Bicolor Smart Interface」：57px Demibold #000，居中，ink 顶 y26105 */
.ssm-bs-h {
  position: absolute;
  left: calc(50% - 0.0068rem);
  top: 5.3281rem;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Demibold';
  font-size: 0.3869rem;
  letter-spacing: 0;
  word-spacing: -0.00815rem;
  line-height: 1;
  color: #000000;
  white-space: nowrap;
}
/* 两行副标题：39px Medium #666666，居中，行距 64px */
.ssm-bs-sub { margin: 0; padding: 0; }
.ssm-bs-s {
  position: absolute;
  left: calc(50% - 0.0068rem);
  transform: translateX(-50%);
  font-family: 'MiSans-Medium';
  font-size: 0.2647rem;
  letter-spacing: 0;
  word-spacing: 0;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
}
.ssm-bs-s1 { top: 6.0814rem; }
.ssm-bs-s2 { top: 6.5091rem; letter-spacing: 0.0008rem; }
/* 深色 UI 面板整块切图：设计 x101 y26395，903×523 */
.ssm-bs-panel {
  position: absolute;
  left: 0.6855rem;
  top: 7.3167rem;
  width: 6.1290rem;
  display: block;
}
/* 图例「Blue: Implant motor+ Surgical motor」：37px Normal，Blue 蓝 #3BAEFF */
.ssm-bs-legend { margin: 0; padding: 0; }
.ssm-bs-blue {
  position: absolute;
  left: 1.5683rem;
  top: 11.1656rem;
  font-family: 'MiSans-Medium';
  font-size: 0.2511rem;
  letter-spacing: 0;
  line-height: 1;
  color: #3BAEFF;
  white-space: nowrap;
}
.ssm-bs-blk {
  position: absolute;
  left: 2.3349rem;
  top: 11.1656rem;
  font-family: 'MiSans-Medium';
  font-size: 0.2511rem;
  letter-spacing: 0;
  line-height: 1;
  color: #000000;
  white-space: nowrap;
}

/* ---------- Dual Irrigation Supply System ---------- */
/* 段顶 = y27046，纯白底；段高 1298px = 8.8100rem（至 y28344 灌溉照片顶） */
.ssm-ds {
  position: relative;
  width: 100%;
  height: 8.8100rem;
  background: #FFFFFF;
}
/* 绿色 UI 面板整块切图：设计 x101 y27067，903×522 */
.ssm-ds-panel {
  position: absolute;
  left: 0.6855rem;
  top: 0.1425rem;
  width: 6.1290rem;
  display: block;
}
/* 图例「Green: Piezosurgery」：36px Medium，Green 绿 #10BC8C */
.ssm-ds-legend { margin: 0; padding: 0; }
.ssm-ds-green {
  position: absolute;
  left: 2.4977rem;
  top: 3.9949rem;
  font-family: 'MiSans-Medium';
  font-size: 0.2443rem;
  letter-spacing: 0;
  line-height: 1;
  color: #10BC8C;
  white-space: nowrap;
}
.ssm-ds-blk {
  position: absolute;
  left: 3.4615rem;
  top: 3.9949rem;
  font-family: 'MiSans-Medium';
  font-size: 0.2443rem;
  letter-spacing: 0;
  line-height: 1;
  color: #1D1D1D;
  white-space: nowrap;
}
/* 标题「Dual Irrigation Supply System」：57px Demibold #000，居中，ink 顶 y27877 */
.ssm-ds-h {
  position: absolute;
  left: calc(50% - 0.0034rem);
  top: 5.6199rem;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Demibold';
  font-size: 0.3869rem;
  letter-spacing: 0;
  word-spacing: -0.00815rem;
  line-height: 1;
  color: #000000;
  white-space: nowrap;
}
/* 四行说明：42.7px Medium #666666，居中，行距 69px */
.ssm-ds-desc { margin: 0; padding: 0; }
.ssm-ds-d {
  position: absolute;
  left: calc(50% - 0.0068rem);
  transform: translateX(-50%);
  font-family: 'MiSans-Medium';
  font-size: 0.2898rem;
  letter-spacing: 0;
  word-spacing: 0;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
}
.ssm-ds-d1 { top: 6.4751rem; word-spacing: -0.00543rem; }
.ssm-ds-d2 { top: 6.9434rem; word-spacing: -0.00543rem; }
.ssm-ds-d3 { top: 7.4117rem; word-spacing: -0.00271rem; }
.ssm-ds-d4 { top: 7.8800rem; word-spacing: -0.00271rem; }
/* ---------- Irrigation photo + Wireless Foot Pedal ---------- */
/* 段顶 = y28344（灌溉照片顶），段高 1561px = 10.5949rem（至 y29905 无线脚踏照片顶） */
.ssm-ir {
  position: relative;
  width: 100%;
  height: 10.5949rem;
  /* 底色延续渐变：y28344–29240 纯白，之后以 ~0.0065 gray/px 降至 y29905 的 #FAFAFA */
  background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 57.40%, #FAFAFA 100%);
}
/* 灌溉场景照片：设计 x38 y28344，1030×839（四角圆角随图，白底与页面同色） */
.ssm-ir-photo {
  position: absolute;
  left: 0.2579rem;
  top: 0;
  width: 6.9910rem;
  display: block;
}
/* 标题「Wireless Foot Pedal」：57px Demibold #000，居中，ink 顶 y29397 */
.ssm-ir-h {
  position: absolute;
  left: calc(50% - 0.0068rem);
  top: 7.1281rem;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Demibold';
  font-size: 0.3869rem;
  letter-spacing: 0;
  word-spacing: -0.00815rem;
  line-height: 1;
  color: #000000;
  white-space: nowrap;
}
/* 五行说明：39px Medium #666666，居中，行距 63.3px */
.ssm-ir-desc { margin: 0; padding: 0; }
.ssm-ir-d {
  position: absolute;
  left: calc(50% - 0.0068rem);
  transform: translateX(-50%);
  font-family: 'MiSans-Medium';
  font-size: 0.2647rem;
  letter-spacing: 0;
  word-spacing: 0;
  line-height: 1;
  color: #666666;
  white-space: nowrap;
}
.ssm-ir-d1 { top: 7.9282rem; }
.ssm-ir-d2 { top: 8.3552rem; }
.ssm-ir-d3 { top: 8.7825rem; }
.ssm-ir-d4 { top: 9.2104rem; }
.ssm-ir-d5 { top: 9.6448rem; }
/* ---------- Wireless foot pedal photo + Meets Diverse Clinical Needs scene ---------- */
/* 段顶 = y29905（脚踏产品照顶），段高 2095px = 14.2195rem（至设计稿末 y32000）；文字全部为 HTML，只有照片是图片 */
.ssm-sw {
  position: relative;
  width: 100%;
  height: 14.2195rem;
  overflow: hidden;
  /* 场景图顶部为 alpha 渐隐，需与页面 245 灰底融合 */
  background: #F5F5F5;
}
/* 无线脚踏产品照：设计 y29905–30694，全宽 1105×789（含底部投影渐隐，与页面 245 灰自然衔接） */
.ssm-sw-pedal {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  display: block;
}
/* 临床场景图（素材 18.png，850×958，顶部空白已裁）：1.3 倍铺满全宽 → 1105×1245，设计顶 y30755 */
.ssm-sw-bg {
  position: absolute;
  left: 0;
  top: 5.7692rem;
  width: 100%;
  display: block;
}
/* 标题「Meets Diverse Clinical Needs」：57px Demibold #000，居中，ink 顶 y30755 */
.ssm-sw-h {
  position: absolute;
  left: calc(50% - 0.0102rem);
  top: 5.7493rem;
  transform: translateX(-50%);
  margin: 0;
  padding: 0;
  font-family: 'MiSans-Demibold';
  font-size: 0.3869rem;
  letter-spacing: -0.0007rem;
  word-spacing: 0;
  line-height: 1;
  color: #000000;
  white-space: nowrap;
}
/* 三行说明：41px Normal #333333，居中，行距 63px */
.ssm-sw-desc { margin: 0; padding: 0; }
.ssm-sw-d {
  position: absolute;
  left: calc(50% - 0.0034rem);
  transform: translateX(-50%);
  font-family: 'MiSans-Medium';
  font-size: 0.2783rem;
  letter-spacing: 0;
  word-spacing: 0;
  line-height: 1;
  color: #333333;
  white-space: nowrap;
}
.ssm-sw-d1 { top: 6.4819rem; letter-spacing: -0.0004rem; }
.ssm-sw-d2 { top: 6.9095rem; letter-spacing: 0.0006rem; }
.ssm-sw-d3 { top: 7.3371rem; letter-spacing: -0.0005rem; }


</style>
